import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Mobil-freundlicher Wrapper für breite Tabellen: horizontaler Scroll auf
 * schmalen Viewports (`.sec-table-scroll`), als a11y-Region ausgewiesen.
 */
export const ResponsiveTable = forwardRef(function ResponsiveTable({ className, caption, children, ...rest }, ref) {
    return (_jsx("div", { ref: ref, className: cn('sec-table-scroll', className), role: "region", "aria-label": caption, ...rest, children: children }));
});
